<div class="p-6 max-w-2xl mx-auto min-h-screen">
  <div class="flex items-center justify-center relative mb-8">
    <div class="absolute left-0">
      <app-metro-button variant="text" (clicked)="cancel()">
        <div class="flex items-center gap-2">
          <app-metro-icon [svg]="iconBack" size="20"></app-metro-icon>
          <span class="hidden md:inline">{{ '::Back' | abpLocalization }}</span>
        </div>
      </app-metro-button>
    </div>
    <h3 class="text-2xl font-bold text-metro-blue-secondary">{{ (isEditMode ? '::EditCommunication' : '::NewCommunication') | abpLocalization }}</h3>
  </div>

  <div class="bg-white rounded-xl border border-gray-100 p-8 shadow-sm">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
      
      <!-- Message -->
      <app-metro-form-textarea
        [label]="'::Message' | abpLocalization"
        [placeholder]="'Ej: 3 cuotas sin interés, 10% OFF en transferencias, etc.'"
        formControlName="message"
        [error]="getErrorMessage('message')"
        [maxlength]="500"
        minHeightClass="min-h-24"
      ></app-metro-form-textarea>

      <!-- Image Upload -->
      <div class="space-y-3">
        <label class="block text-sm font-medium text-gray-700">{{ '::ImageOptional' | abpLocalization }}</label>
        
        <app-metro-upload-images
          [initialImageUrl]="imagePreviewUrl"
          [accept]="'image/jpeg,image/png,image/svg+xml,image/webp'"
          [multiple]="false"
          (imageSelected)="onImageSelected($event)">
        </app-metro-upload-images>

        <div class="text-xs text-gray-500">
          {{ '::ImageUploadHelp' | abpLocalization }}
        </div>
      </div>

      <!-- Active Status -->
      <div class="flex items-center">
        <label class="flex items-center gap-2.5 cursor-pointer select-none">
          <input type="checkbox" formControlName="isActive" class="w-4 h-4 rounded border-gray-300 text-metro-blue focus:ring-metro-blue">
          <span class="text-sm font-medium text-gray-700">{{ '::IsActive' | abpLocalization }}</span>
        </label>
      </div>

      <!-- Action Buttons -->
      <div class="flex justify-between items-center pt-4 mt-6 border-t border-gray-50">
        <div>
          <app-metro-button
            *ngIf="isEditMode"
            variant="danger"
            text="{{ '::Delete' | abpLocalization }}"
            (clicked)="deleteCommunication()"
            type="button"
          ></app-metro-button>
        </div>
        <div class="flex justify-end gap-3">
          <app-metro-button
            variant="text"
            [text]="'::Cancel' | abpLocalization"
            (clicked)="cancel()"
            type="button"
          ></app-metro-button>
          <app-metro-button
            variant="secondary"
            [text]="(isEditMode ? '::SaveChanges' : '::Create') | abpLocalization"
            type="submit"
            [disabled]="isUploading"
          ></app-metro-button>
        </div>
      </div>
    </form>
  </div>
</div>
